<template>
	<page class="activity activityinfo" id="top" @scrollChange="scrollChange">
		<ZuiHeader />
		<PageNavigater></PageNavigater>
		<!-- 景点介绍加map -->
		<div class="detailClass ">
			<div class="contain">
				<div class="content">
					<div class="bg">
						<div class="title">{{ title }}
							<div class="tuijianstar">
								<span>发表时间：{{ createTime }}</span>
								<span>来源：{{ articleData.ext4 || '峨眉山旅游网' }}</span>
								<span>作者：{{ articleData.ext3 || '未知' }}</span>
								<span>阅读：{{ browse }}</span>
							</div>
							<div class="title-bg"></div>
						</div>
						<div v-viewer="options" class="richtext" ref="richEl"></div>
						<div class="reviewInformation"> 
							<div v-if="articleData.editor">编辑：{{articleData.editor	}}</div>
							<div v-if="articleData.executiveEditor">责任编辑：{{articleData.executiveEditor	}}</div>
							<div v-if="articleData.auditor">审核：{{articleData.auditor	}}</div>
						</div>
						<div class="article-content">
							<span class="none" v-if="!prevArticle.id">上一篇：暂无</span>
							<a class="article-pre" @click="relatedPNClick(prevArticle.id)"
								v-else>上一篇：{{ prevArticle.title }}</a>
							<span class="none" v-if="!nextArticle.id">下一篇：暂无</span>
							<a class="article-next" @click="relatedPNClick(nextArticle.id)"
								v-else>下一篇：{{ nextArticle.title }}</a>
						</div>
					</div>
				</div>
				<!-- <div class="detailButton1" v-if="showButton" @click="back()">
					<span>返回上级</span>
				</div> -->
				<div class="detailButton2" @click="toTop()">
					<span>回到顶部</span>
				</div>
			</div>
		</div>
		<ZuiFooter />
	</page>
</template>

<script>
	import {
		getArticle,
		getArticles,
		getArticleAdjacent
	} from '~/api/CmsApi'
	import '../less/detail.css'
	import '../less/activity.css'
	import moment from "moment";
	export default {
		data() {
			return {
				showButton: false,
				activeIndex: 0,
				articleData: {},
				star: 0,
				title: '',
				ext1: '',
				createTime: '',
				browse: '',
				articleLoading: false,
				relatedLoading: true,
				relatedList: [],
				prevArticle: {},
				nextArticle: {},
				options: {
					inline: false,
					button: true,
					navbar: true,
					title: false,
					toolbar: true,
					tooltip: true,
					movable: true,
					zoomable: true,
					rotatable: true,
					scalable: true,
					transition: true,
					fullscreen: true,
					keyboard: true,
					// url: 'data-source',
				},
				isIE: false,
				isUC: false
			}
		},
		created() {
			if (document.documentMode)
				this.isIE = true;
			if (navigator.appVersion.indexOf('UBrowser/'))
				this.isUC = true;
			if ((this.isIE || this.isUC) && !document.body.scrollTo) {
				Element.prototype.scrollTo = function(option) {
					this.scrollLeft = option.left;
					this.scrollTop = option.top;
				};
			}
		},
		mounted: function() {
			const id = this.$route.query.id;
			if (id) {
				this.getArticle(id);
			}

			this.$nextTick(function() {
				window.addEventListener('scroll', this.onScroll);
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			})
		},
		beforeDestroy() {
			window.addEventListener('scroll', this.onScroll);
		},

		watch: {
			activeIndex: {
				handler(value) {
					if (this.map) {
						const articleId = this.swiperSlides[value].id;
						this.getArticle(articleId);
					}
				},
				immediate: true
			}
		},
		methods: {
			getArticle(id) {
				this.articleLoading = true;
				getArticle(id).then(res => {
					if (res.code === 0) {
						this.renderArticle(res.data);
					}
					this.articleLoading = false;
				})
			},
			/**
			 * 渲染文章内容
			 * @param data
			 */
			renderArticle(data) {
				this.title = data.title;
				this.$refs.richEl.innerHTML = data.content;
				this.createTime = moment(data.createTime).format('YYYY年MM月DD日');
				this.browse = data.browse;
				this.star = data.star || 0;
				this.articleData = data;

				if (this.showRelated) {
					this.getRelatedArticle(data.cateId);
				}

				// 获取上一篇、下一篇
				this.getPrevNextArticle(data.id, data.cateId, data.createTime);
			},
			getPrevNextArticle(id, cateId, createTime) {
				getArticleAdjacent({
					id,
					cateId,
					createTime
				}).then(res => {
					if (res.code === 0) {
						this.prevArticle = res.data[0] || {
							title: '暂无'
						};
						this.nextArticle = res.data[1] || {
							title: '暂无'
						};
					}
				});
			},
			/**
			 * 获取相关文章
			 */
			getRelatedArticle(cateId) {
				const param = {
					page: 1,
					limit: 8,
					cateId
				};
				this.relatedLoading = true;
				getArticles(param).then(res => {
					if (res.code === 0) {
						const list = res.data.records || [];
						this.relatedList = list.map(item => {
							item.createTime = item.createTime || item.updateTime;
							return item;
						})
					} else {
						this.relatedList = [];
					}
					this.relatedLoading = false;
				})
			},
			onScroll() {
				let scrolled = document.documentElement.scrollTop || document.body.scrollTop // 586、1063分别为第二个和第三个锚点对应的距离
				if (scrolled > 300) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			},
			back() {
				this.$router.go(-1)
			},
			toTop() {
				if (this.isIE || this.isUC)
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTop = 0;
				else
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTo({top: 0, behavior: 'smooth'})
			},
			mapTab(e) {
				this.activeIndex = index
			},
			clickStar(index) {
				this.activeIndex = index
				this.swiper.slideTo(index, 1000, false)
				this.title = this.swiperSlides[this.activeIndex].name;
			},
			relatedClick(item) {
				const base = this.$router.options.base;
				let route = this.$route.path;
				if (base) {
					route = base + route.substring(1);
				}
				const id = this.isNotice ? item.contentId : item.id;
				window.location.href = `${route}?id=${id}`;
			},
			relatedPNClick(id) {
				if (id) {
					const base = this.$router.options.base;
					let route = this.$route.path;
					if (base) {
						route = base + route.substring(1);
					}
					window.location.href = `${route}?id=${id}`;
				}
			},
			scrollChange(height) {
				if (height > 300) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/visitor/activityInfo.vue